export const STAMPS = {
    COMMENCED: 'commenced',
    COMPLETED: 'completed',
    FOCUSED: 'focused',
}